import React from "react";

import PropTypes from "prop-types";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

import {
  query,
  collection as firebaseCollection,
  onSnapshot,
  orderBy,
  where,
  getCountFromServer,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useSelector } from "react-redux";
import { DEFAULT_COVER_URL } from "../../common/enum";
import NotificationCard from "./NotificationCard";

function TabPanel(props) {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ ...sx }}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const NotifcationPanel = ({
  drawerState,
  toggleDrawer,
  setMessageUnReadCount,
  t,
}) => {
  const [value, setValue] = React.useState(0);
  const [notifcations, setNotifications] = React.useState([]);
  const {
    auth: { profile },
  } = useSelector((state) => state);

  React.useEffect(() => {
    const getData = () => {
      const q = query(
        firebaseCollection(db, "notifications"),
        where("donorUserId", "==", profile?.userId),
        orderBy("updatedDate", "desc")
      );
      const unsub = onSnapshot(q, async (snap) => {
        const arr = [];
        for (let doc of snap.docs) {
          arr.push({
            ...doc.data(),
          });
        }
        setNotifications([...arr]);
      });
      return () => {
        unsub();
      };
    };
    profile?.userId && getData();
  }, [profile]);

  return (
    <Drawer
      anchor={"right"}
      open={drawerState}
      onClose={() => toggleDrawer(false)}
      PaperProps={{
        sx: { width: "50%" },
      }}
    >
      <Button
        sx={{
          position: "fixed",
          right: "51%",
          top: 10,
          zIndex: 1,
          minWidth: 0,
          padding: "4px",
          borderRadius: "4px",
          backgroundColor: "#ffc3c3",
          "&:hover": {
            backgroundColor: "#ffc3c3",
          },
        }}
        onClick={() => toggleDrawer(false)}
      >
        <CloseOutlinedIcon color="error" />
      </Button>
      <Box
        sx={{
          width: 1,
          bgcolor: "background.paper",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body1"
          gutterBottom
          sx={{ p: 1, textAlign: "center", fontWeight: 600 }}
        >
          {t("notifications")}
        </Typography>
        {notifcations.length === 0 && (
          <Typography variant="body1" sx={{ m: "auto" }}>
            {t("noChat")}
          </Typography>
        )}
        {notifcations.length > 0 &&
          notifcations.map((item, i) => (
            <NotificationCard notification={item} t={t} key={i} />
          ))}
      </Box>
    </Drawer>
  );
};

export default NotifcationPanel;
